import {
  VEHICLE_UPDATE_REQUEST, VEHICLE_UPDATE_SUCCESS, VEHICLE_UPDATE_ERROR,
  VEHICLE_CREATE_BY_FASECOLDA_REQUEST, VEHICLE_CREATE_BY_FASECOLDA_SUCCESS, VEHICLE_CREATE_BY_FASECOLDA_ERROR,
  VEHICLE_CREATE_BY_PLATE_REQUEST, VEHICLE_CREATE_BY_PLATE_SUCCESS, VEHICLE_CREATE_BY_PLATE_ERROR,
  VEHICLE_CREATE_REQUEST, VEHICLE_CREATE_SUCCESS, VEHICLE_CREATE_ERROR,
  GLOBAL_QUOTATION_RESET_STATE_VEHICLE, VEHICLE_CREATE_BY_REFERENCE_REQUEST,
  VEHICLE_CREATE_BY_REFERENCE_SUCCESS,
  VEHICLE_CREATE_BY_REFERENCE_ERROR,
} from 'Redux/types/globalQuotationTypes';

import { BACKEND_URL_VEHICLE } from 'Config/routes';
import { CALL_ACTIONS } from 'Redux/middleware';


// -------------------- -------------------- -------------------- --------------------
// Actualizar datos del vehiculo
const updateVehicleDataAction = (vehicleId, data) => {

  const valor_asegurado_updated = 'valor_asegurado' in data;
  const confirm = 'confirm' in data;

  return {
    [CALL_ACTIONS]: {
      TYPES: [VEHICLE_UPDATE_REQUEST, VEHICLE_UPDATE_SUCCESS, VEHICLE_UPDATE_ERROR],
      ENDPOINT: `${BACKEND_URL_VEHICLE}${vehicleId}/`,
      METHOD: 'PUT',
      DATA: data,
    },
    valor_asegurado_updated,
    confirm,
  };
};

export const updateVehicleData = (vehicleId, data) => (dispatch) => dispatch(updateVehicleDataAction(vehicleId, data));


// -------------------- -------------------- -------------------- --------------------
// Actualizar datos del vehiculo FASECOLDA
const updateVehicleByFasecoldaAction = (data) => ({
  [CALL_ACTIONS]: {
    TYPES: [
      VEHICLE_CREATE_BY_FASECOLDA_REQUEST,
      VEHICLE_CREATE_BY_FASECOLDA_SUCCESS,
      VEHICLE_CREATE_BY_FASECOLDA_ERROR,
    ],
    ENDPOINT: `${BACKEND_URL_VEHICLE}get_fasecolda/`,
    METHOD: 'GET',
    // DATA: {},
    PARAMS: data,
  },
});

export const updateVehicleByFasecolda = (data) => (dispatch) => dispatch(updateVehicleByFasecoldaAction(data));

// -------------------- -------------------- -------------------- --------------------
// Actualizar datos del vehiculo PLACA
const updateVehicleByPlate = (data) => ({
  [CALL_ACTIONS]: {
    TYPES: [
      VEHICLE_CREATE_BY_PLATE_REQUEST,
      VEHICLE_CREATE_BY_PLATE_SUCCESS,
      VEHICLE_CREATE_BY_PLATE_ERROR,
    ],
    ENDPOINT: `${BACKEND_URL_VEHICLE}get_by_plate/`,
    METHOD: 'GET',
    PARAMS: data,
  },
});

export const sendVehiclePlate = (data) => (dispatch) => dispatch(updateVehicleByPlate(data));

// -------------------- -------------------- -------------------- --------------------
// Crea un vehiculo desde cero
const createNewVehicleAction = (data) => ({
  [CALL_ACTIONS]: {
    TYPES: [VEHICLE_CREATE_REQUEST, VEHICLE_CREATE_SUCCESS, VEHICLE_CREATE_ERROR],
    ENDPOINT: BACKEND_URL_VEHICLE,
    METHOD: 'POST',
    DATA: data,
  },
});

export const createNewVehicle = (data) => (dispatch) => dispatch(createNewVehicleAction(data));

// ------------------------------------ ------------------------------------ ------------------------------------
const resetGlobalQuotationVehicleAction = (defaults) => ({
  type: GLOBAL_QUOTATION_RESET_STATE_VEHICLE,
  defaults,
});

export const resetGlobalQuotationVehicle = (defaults = {}) => (dispatch) => dispatch(resetGlobalQuotationVehicleAction(defaults));

// -------------------- -------------------- -------------------- --------------------
// Actualizar datos del vehiculo REFERENCIA
const updateVehicleByReference = (data) => ({
  [CALL_ACTIONS]: {
    TYPES: [
      VEHICLE_CREATE_BY_REFERENCE_REQUEST,
      VEHICLE_CREATE_BY_REFERENCE_SUCCESS,
      VEHICLE_CREATE_BY_REFERENCE_ERROR,
    ],
    ENDPOINT: `${BACKEND_URL_VEHICLE}get_codefasecolda_by_brand_model_line/`,
    METHOD: 'GET',
    PARAMS: data,
  },
});

export const sendVehicleReference = (data) => (dispatch) => dispatch(updateVehicleByReference(data));
